<template>
	<a href="#" @click.prevent.stop="$emit('click')" class="icon-action">
		<icon :icon="icon"></icon>
	</a>
</template>

<script>
	export default {
		computed: {
			icon() {
				if(!this.$slots.default || !this.$slots.default[0]) {
					return null;
				}
				return this.$slots.default[0].text;
			}
		}
	}
</script>